import { AccordionGroup, ActionChip, ChipGroup, H3 } from '@zooplus/ui-components';
import { useTranslation } from '../../hooks/use-translations';
import React, { useEffect, useState } from 'react';
import { Question, questions } from '../../data/data';
import { FaqQuestion } from './faq-question/FaqQuestion';
import styles from './Faq.module.scss';

export const Faq = () => {
  const { t } = useTranslation();
  const [questionDisplay, setQuestionDisplay] = useState(
    questions.filter((question) => question.category == 'CREATION'),
  );
  const [questionAccordion, setQuestionAccordion] = useState(<></>);
  const [categorySelected, setCategorySelected] = useState('CREATION');

  useEffect(() => {
    setQuestionDisplay(questions.filter((question) => question.category === categorySelected));
  }, [categorySelected]);

  useEffect(() => {
    setQuestionAccordion(questionsToDisplay(questionDisplay));
  }, [questionDisplay]);

  const categories = [...new Set(questions.map((question) => question.category))];

  const questionsToDisplay = (questionDisplay: Question[]) => {
    if (questionDisplay.length == 0) return <></>;
    return (
      <AccordionGroup
        allowMultipleOpen={false}
        size={'small'}
        key={`question-group-${categorySelected}`}
        id={`question-group-${categorySelected}`}>
        {questionDisplay.map((question) => (
          <FaqQuestion
            key={`question-${question.questionPrefix.replace('.', '-')}`}
            question={question}
          />
        ))}
      </AccordionGroup>
    );
  };

  return (
    <section>
      <H3 className={styles.title}>{t('faq.title')}</H3>
      <ChipGroup className="pp-mb-m">
        {categories.map((category) => (
          <ActionChip
            key={`category-${category.replace('_', '-').toLowerCase()}`}
            id={`category-${category.replace('_', '-').toLowerCase()}`}
            label={t(`faq.categories.${category.replace('_', '-').toLowerCase()}`)}
            onClick={() => setCategorySelected(category)}
            selected={category == categorySelected}
          />
        ))}
      </ChipGroup>
      {questionAccordion}
    </section>
  );
};
